// BPS-account login screen. There is no Microsoft/Entra sign-in — all auth
// goes through the cross-app handoff to bps-corp.com (the same magic-link
// local account AskBI uses). The button kicks off /AuthBridge/Login, which
// redirects to the BPS sign-in and lands the user back at '/'.

export default function Login() {
  function handleSignIn() {
    window.location.href = '/AuthBridge/Login?returnUrl=/';
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>Time Tracker</h1>
        <p style={{ fontSize: 13, color: '#737370', marginBottom: 20 }}>
          Sign in with your BPS account.
        </p>
        <button
          className="btn-primary"
          style={{ width: '100%', justifyContent: 'center', padding: '10px' }}
          onClick={handleSignIn}
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
